import { render, staticRenderFns } from "./ProductElement.vue?vue&type=template&id=27073921&scoped=true&"
import script from "./ProductElement.vue?vue&type=script&lang=js&"
export * from "./ProductElement.vue?vue&type=script&lang=js&"
import style0 from "./ProductElement.vue?vue&type=style&index=0&id=27073921&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27073921",
  null
  
)

export default component.exports